__turbopack_context__.v({
  "container": "Search-module-scss-module__-GV2YG__container",
  "input": "Search-module-scss-module__-GV2YG__input",
  "input--open": "Search-module-scss-module__-GV2YG__input--open",
  "input-wrapper": "Search-module-scss-module__-GV2YG__input-wrapper",
  "list": "Search-module-scss-module__-GV2YG__list",
  "list-item": "Search-module-scss-module__-GV2YG__list-item",
  "list-item--highlighted": "Search-module-scss-module__-GV2YG__list-item--highlighted",
  "submit": "Search-module-scss-module__-GV2YG__submit",
});
